import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import type { DonViCoSo, KhoHang, MaterialUnitInfo, VatTu, ViTri } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<MaterialUnitInfo>[] => [
  {
    field: 'unit_data',
    headerName: 'Đơn vị',
    width: 250,
    renderCell: (params: DataTableRenderCellParams<MaterialUnitInfo>) => params.row.unit_data?.name || ''
  },
  {
    field: 'ma_vat_tu_data',
    headerName: 'Mã vật tư',
    width: 120,
    renderCell: (params: DataTableRenderCellParams<MaterialUnitInfo>) => {
      return params.row.ma_vat_tu_data?.ma_vt || '';
    }
  },
  {
    field: 'ten_vat_tu',
    headerName: 'Tên vật tư',
    width: 190,
    renderCell: (params: DataTableRenderCellParams<MaterialUnitInfo>) => params.row.ma_vat_tu_data?.ten_vt || ''
  },
  {
    field: 'ma_kho_data',
    headerName: 'Mã kho',
    width: 180,
    renderCell: (params: DataTableRenderCellParams<MaterialUnitInfo>) => params.row.ma_kho_data?.ma_kho || ''
  },
  {
    field: 'ten_kho',
    headerName: 'Tên kho',
    width: 200,
    renderCell: (params: DataTableRenderCellParams<MaterialUnitInfo>) => params.row.ma_kho_data?.ten_kho || ''
  },
  {
    field: 'ma_vi_tri_data',
    headerName: 'Mã vị trí',
    width: 100,
    renderCell: (params: DataTableRenderCellParams<MaterialUnitInfo>) => params.row.ma_vi_tri_data?.ma_vi_tri || ''
  },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 120,
    renderCell: (params: DataTableRenderCellParams<MaterialUnitInfo>) =>
      params.row.status === '1' ? '1. Còn sử dụng' : '0. Không sử dụng'
  }
];

export const vatTuSearchColumns: DataTableColumn<VatTu>[] = [
  { field: 'ma_vt', headerName: 'Mã vật tư', width: 120 },
  { field: 'ten_vt', headerName: 'Tên vật tư', width: 250 },
  {
    field: 'dvt_data',
    headerName: 'Đvt',
    width: 80,
    renderCell: (params: DataTableRenderCellParams<VatTu>) => params.row.dvt_data?.dvt || ''
  },
  { field: 'nh_vt1', headerName: 'Nhóm 1', width: 120 },
  { field: 'lo_yn', headerName: 'Theo dõi lô', width: 120, checkboxSelection: true },
  { field: 'qc_yn', headerName: 'Quy cách', width: 120, checkboxSelection: true },
  { field: 'hinh_anh', headerName: 'Hình ảnh', width: 120 }
];

export const khoSearchColumns: DataTableColumn<KhoHang>[] = [
  { field: 'ma_kho', headerName: 'Mã kho', width: 120 },
  { field: 'ten_kho', headerName: 'Tên kho', width: 250 },
  { field: 'don_vi', headerName: 'Đơn vị', width: 120 },
  { field: 'theo_doi_vi_tri', headerName: 'Theo dõi vị trí', width: 120 }
];

export const viTriSearchColumns: DataTableColumn<ViTri>[] = [
  { field: 'ma_vi_tri', headerName: 'Mã vị trí', width: 120 },
  { field: 'ten_vi_tri', headerName: 'Tên vị trí', width: 250 }
];

export const donViSearchColumns: DataTableColumn<DonViCoSo>[] = [
  { field: 'ma_unit', headerName: 'Mã đơn vị', width: 120 },
  { field: 'ten_unit', headerName: 'Tên đơn vị', width: 250 }
];
